// Add this line outside to confirm the script block is even processed
console.log('%cIron Decoy - Size Guide Script START', 'color: blue; font-weight: bold;'); // Changed console log prefix for clarity

document.addEventListener('DOMContentLoaded', function() {

  // Add this line inside DOMContentLoaded
  console.log('Iron Decoy - DOMContentLoaded event fired for Size Guide');

  // --- Solution A: Add a small delay ---
  // We suspect the elements might not be ready immediately after DOMContentLoaded
  // Let's wait 300ms before trying to find them.
  setTimeout(function() {
    console.log('Iron Decoy - Running Size Guide script inside setTimeout (300ms delay)');

    // Get references to the elements INSIDE the setTimeout
    var openLink = document.getElementById('open-size-guide-link');
    var modal = document.getElementById('size-guide-modal');
    var closeButton = document.getElementById('close-size-guide-modal');

    // Log whether the elements were found
    console.log('Iron Decoy - openLink found:', openLink);
    console.log('Iron Decoy - modal found:', modal);
    console.log('Iron Decoy - closeButton found:', closeButton);

    // Check if all elements exist to prevent errors
    if (openLink && modal && closeButton) {

      console.log('Iron Decoy - All Size Guide elements found. Adding listeners...');

      // Function to open the modal
      function openModal(event) {
        console.log('%cIron Decoy - openModal function CALLED', 'color: green; font-weight: bold;'); // Log when function starts
        event.preventDefault(); // Stop the link from navigating
        console.log('Iron Decoy - Default prevented for size guide link');

        // Double-check modal exists right before changing style
        if (modal) {
             modal.style.display = 'flex'; // Show the modal (using flex as set in CSS)
             console.log('Iron Decoy - Size Guide Modal display set to flex');
        } else {
             console.error('Iron Decoy - ERROR: Size Guide Modal element became null inside openModal!');
        }
      }

      // Function to close the modal
      function closeModal() {
        console.log('%cIron Decoy - closeModal function CALLED', 'color: red; font-weight: bold;'); // Log when function starts
        // Double-check modal exists right before changing style
         if (modal) {
             modal.style.display = 'none'; // Hide the modal
             console.log('Iron Decoy - Size Guide Modal display set to none');
         } else {
             console.error('Iron Decoy - ERROR: Size Guide Modal element became null inside closeModal!');
         }
      }

      // Event listener for the trigger link
      openLink.addEventListener('click', openModal);
      console.log('Iron Decoy - Click listener added to openLink for Size Guide');

      // Event listener for the close button
      closeButton.addEventListener('click', closeModal);
      console.log('Iron Decoy - Click listener added to closeButton for Size Guide');

      // Event listener to close modal if clicking outside the content area
      modal.addEventListener('click', function(event) {
        if (event.target === modal) {
          console.log('Iron Decoy - Size Guide Modal overlay clicked, closing modal');
          closeModal();
        }
      });
      console.log('Iron Decoy - Click listener added to modal overlay for Size Guide');


      // Optional: Close modal on 'Escape' key press
      document.addEventListener('keydown', function(event) {
          // Check if modal exists and is visible
          if (modal && modal.style.display === 'flex' && event.key === 'Escape') {
              console.log('Iron Decoy - Escape key pressed, closing Size Guide modal');
              closeModal();
          }
      });
      console.log('Iron Decoy - Keydown listener added to document for Size Guide');


        } else {
      // Log an error if elements aren't found - this would indicate an issue
      // as they are expected on product pages now.
      console.error('Iron Decoy - ERROR: Crucial Size Guide elements (link, modal, or close button) not found on product page AFTER setTimeout. Link:', openLink, 'Modal:', modal, 'CloseBtn:', closeButton);
    }

  }, 300); // 300 milliseconds delay

}); // End DOMContentLoaded

console.log('%cIron Decoy - Size Guide Script END', 'color: blue; font-weight: bold;');